var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTopAboutIcon1 = function SvgTopAboutIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 146,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "top-about-icon_1_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 220,
    height: 146
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h220v146H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#top-about-icon_1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.912 15.073 37.068 30.948V81.36a2.566 2.566 0 0 0 2.563 2.568h54.74a2.566 2.566 0 0 0 2.563-2.568V17.637a2.566 2.566 0 0 0-2.562-2.568h-41.46v.004Z",
    fill: "#fff",
    stroke: "#13A2F2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.912 15.073v15.875H37.068",
    stroke: "#13A2F2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.726 33.073h22.549M55.726 41.653h22.549M55.726 50.235h22.549M78.334 33.743v15.404M67 33.743v15.404M55.667 33.743v15.404M43.059 53.853h22.549M43.059 62.433h22.549M43.059 71.015h22.549M65.667 54.523v15.404M54.333 54.523v15.404M43 54.523v15.404M68.392 53.853H90.94M68.392 62.433H90.94M68.392 71.015H90.94M91 54.523v15.404M79.666 54.523v15.404M68.333 54.523v15.404",
    stroke: "#13A2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.912 26.073 47.068 41.948V92.36a2.566 2.566 0 0 0 2.563 2.568h54.741a2.566 2.566 0 0 0 2.562-2.568V28.637a2.566 2.566 0 0 0-2.562-2.568h-41.46v.004Z",
    fill: "#fff",
    stroke: "#13A2F2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.912 26.073v15.875H47.068",
    stroke: "#13A2F2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.726 44.073h22.549M65.726 52.653h22.549M65.726 61.235h22.549M88.334 44.743v15.404M77 44.743v15.404M65.667 44.743v15.404M53.059 64.853h22.549M53.059 73.433h22.549M53.059 82.015h22.549M75.667 65.523v15.404M64.333 65.523v15.404M53 65.523v15.404M78.392 64.853h22.549M78.392 73.433h22.549M78.392 82.015h22.549M101 65.523v15.404M89.666 65.523v15.404M78.333 65.523v15.404",
    stroke: "#13A2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 39,
    width: 58,
    height: 73,
    rx: 2,
    fill: "#fff",
    stroke: "#13A2F2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.059 53h22.549M77.059 61.58h22.549M77.059 70.162h22.549M99.667 53.67v15.404M88.333 53.67v15.404M77 53.67v15.404M64.059 79h22.549M64.059 87.58h22.549M64.059 96.162h22.549M86.667 79.67v15.404M75.333 79.67v15.404M64 79.67v15.404M89.392 79h22.549M89.392 87.58h22.549M89.392 96.162h22.549M112 79.67v15.404M100.666 79.67v15.404M89.333 79.67v15.404",
    stroke: "#13A2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.088 53h-68.145c-6.027 0-10.913 4.886-10.913 10.912v44.112c0 6.027 4.886 10.912 10.913 10.912h68.145c6.027 0 10.912-4.885 10.912-10.912V63.912C185 57.886 180.115 53 174.088 53Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.088 53h-68.145c-6.027 0-10.913 4.886-10.913 10.912v44.112c0 6.027 4.886 10.912 10.913 10.912h68.145c6.027 0 10.912-4.885 10.912-10.912V63.912C185 57.886 180.115 53 174.088 53Z",
    fill: "#fff",
    stroke: "#13A2F2",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.03 132.021H185",
    stroke: "#13A2F2",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#top-about-icon_1_svg__b)",
    fill: "#CAEAFA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m154.14 110.539-16.546-4.133-31.301-7.31L119.47 86.76l.267.274-.246-.295.405-.347.075-.284.203.053 6.023-5.164 13.806 2.966-.117.515.128-.515 15.981 3.87 16.098 3.776.437-.431.746.746-19.147 18.615h.011Zm-15.363-4.922 15.043 3.755 5.416-5.259-15.15-3.628-5.309 5.132Zm-15.192-3.565 13.987 3.271 5.299-5.132-14.19-3.397-5.096 5.248v.01Zm21.397-2.43 15.149 3.629 5.16-5.017-15.075-3.67-5.234 5.07v-.011Zm-36.525-1.104 13.923 3.261 5.096-5.259-13.443-3.218-5.576 5.216Zm21.066-2.597 14.233 3.407 5.245-5.069-14.456-3.513-5.022 5.175Zm21.589-2.23 15.075 3.67 5.032-4.89-15.16-3.555-4.936 4.775h-.011ZM114.96 92.44l13.369 3.198 5.022-5.185-12.9-3.145-.256.221-5.245 4.901.01.01Zm20.438-2.566 14.499 3.524 4.925-4.775-14.755-3.576-4.669 4.817v.01Zm-13.956-3.397 12.762 3.103 4.648-4.796-12.356-2.65-5.054 4.333v.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.436 77.558h-2.132v21.56h2.132v-21.56ZM127.625 60.531h-2.132v21.56h2.132v-21.56ZM155.344 87.876h-2.132v21.559h2.132v-21.56ZM173.468 70.302h-2.132v21.56h2.132v-21.56ZM122.295 98.393l15.458 3.681v4.206l-15.458-3.681v-4.206Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.353 80.514 15.458 3.68v4.207l-15.458-3.68v-4.207Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "top-about-icon_1_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(106.293 60.531)",
    d: "M0 0h67.175v50.008H0z"
  })))));
};

export { SvgTopAboutIcon1 as ReactComponent };
export default __webpack_public_path__ + "static/top-about-icon_1.22383660.svg";